/** Shared formatters + constants for the Overview dashboard cards. */
import type { ResolvedRange } from '../analytics/WafRangeControl';

/** Sentinel value for the "All site" / "All domain" scope options. */
export const ALL_SITE = '__all__';

/** Bytes → human size (B/KB/MB/GB/…). Decimal (1000) base to match the vendor. */
export function fmtBytes(n: number): string {
  if (!n) return '0 B';
  const u = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const i = Math.min(u.length - 1, Math.floor(Math.log(n) / Math.log(1000)));
  return `${(n / 1000 ** i).toFixed(2)} ${u[i]}`;
}

/** Count → compact K/M/B. */
export function fmtNum(n: number): string {
  if (Math.abs(n) >= 1e9) return `${(n / 1e9).toFixed(2)} B`;
  if (Math.abs(n) >= 1e6) return `${(n / 1e6).toFixed(2)} M`;
  if (Math.abs(n) >= 1e3) return `${(n / 1e3).toFixed(2)} K`;
  return String(n);
}

export const fmtPct = (n: number) => `${(n ?? 0).toFixed(2)} %`;
export const fmtUsd = (n: number) => `USD ${Math.round((n ?? 0) * 100) / 100}`;

/** Current / last calendar-month range in unix seconds. */
export function monthRange(which: 'current' | 'last'): ResolvedRange {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  if (which === 'current') {
    return {
      start_time: Math.floor(new Date(y, m, 1, 0, 0, 0).getTime() / 1000),
      end_time: Math.floor(now.getTime() / 1000),
    };
  }
  return {
    start_time: Math.floor(new Date(y, m - 1, 1, 0, 0, 0).getTime() / 1000),
    end_time: Math.floor(new Date(y, m, 1, 0, 0, 0).getTime() / 1000) - 1,
  };
}
